import { Component } from '@angular/core';
import {MatCardModule} from '@angular/material/card';

@Component({
    selector: 'app-auth-layout',
    imports: [MatCardModule],
    templateUrl: './auth-layout.component.html',
    styleUrl: './auth-layout.component.css'
})
export class AuthLayoutComponent {

}
